<template>
  <div>
    <!-- Page wrapper start -->
    <div class="pg-wrapper">
      <app-header>
        <div class="title-bar has-text-center" slot="header-foot">
          <h1 class="title">404</h1>
        </div>
      </app-header>
      <main class="content-wrapper has-background-white-bis pb0">
        <div class="columns mv0 flex-grow-1 is-marginless">
          <div  class="column flex-grow-1 section-search-results selected-tab-content content-404">
            <p class="text-center mt-5">404: business or page not found!</p>
          </div>
        </div>
      </main>
      <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
export default {
  name: '404',
  data() {
    return {
    };
  },
};
</script>


